// extracted by css-extract-rspack-plugin
export default {"similarSoldItemColumn":"_40aa6855","similarSoldCurrentItemColumn":"_28b7e27c","wrapper":"_7ec4ba70","itemImageDimensions":"_6f1f6cf2","itemImage":"_2de05eb1"};